import { defineMessages } from 'react-intl';

const _default_1: {
	selectToEditAriaLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	selectToEditAriaLabel: {
		id: 'company-hub.company-hub-common.items-shared.item-container.button.edit.aria-label',
		defaultMessage: 'Select card to edit',
		description: 'Aira label for button that selects card for editing',
	},
});
export default _default_1;
